import ApiClient from '../ApiClient';

class CrmDealTasksAPI extends ApiClient {
    constructor() {
        super('crm/deals', { accountScoped: true });
    }

    getAll(dealId) {
        return axios.get(`${this.url}/${dealId}/tasks`);
    }

    createTask(dealId, data) {
        return axios.post(`${this.url}/${dealId}/tasks`, data);
    }

    updateTask(dealId, taskId, data) {
        return axios.patch(`${this.url}/${dealId}/tasks/${taskId}`, data);
    }

    deleteTask(dealId, taskId) {
        return axios.delete(`${this.url}/${dealId}/tasks/${taskId}`);
    }
}

export default new CrmDealTasksAPI();
